import React, { useEffect, useState } from "react";
import AppUpdateForm from "./AppUpdateForm";
import AdminPageLayout from "../components/AdminPageLayout";
import "../components/AdminPageLayout.css";
import "./appUpdate.css";
import {
  fetchAllAppUpdates,
  deleteAppUpdate as deleteAppUpdateService,
  toggleAppUpdateStatus,
} from "./adminAppUpdateService";

const AdminAppUpdatePage = () => {
  const [updates, setUpdates] = useState([]);
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => { loadUpdates(); }, []);

  const loadUpdates = async () => {
    setLoading(true);
    const res = await fetchAllAppUpdates();
    if (res.status === 200) setUpdates(res.data);
    else alert(res.message || "Failed to load app updates");
    setLoading(false);
  };

  const deleteAppUpdate = async (id) => {
    if (!window.confirm("Delete this app update config?")) return;
    const res = await deleteAppUpdateService(id);
    if (res.status === 200 || res.status === 204) loadUpdates();
    else alert(res.message || "Delete failed");
  };

  const toggleEnable = async (id, currentActive) => {
    const res = await toggleAppUpdateStatus(id, !currentActive);
    if (res.status === 200) loadUpdates();
    else alert(res.message || "Status update failed");
  };

  const onFormSaved = () => { setShowForm(false); loadUpdates(); };

  return (
    <AdminPageLayout
      title="App Update Management"
      subtitle="Control forced and optional update prompts shown in the mobile app."
      instruction="Each config targets a specific platform (Android / iOS). Set the Latest Version to the newest release and Min Supported Version to the oldest version users can run without being forced to update. Only one config per platform should be active at a time."
      actions={
        <button className="adm-btn adm-btn-primary" onClick={() => { setEditing(null); setShowForm(true); }}>
          + New Config
        </button>
      }
    >
      {showForm && (
        <div className="adm-form-card">
          <AppUpdateForm
            appUpdate={editing}
            onSaved={onFormSaved}
            onCancel={() => setShowForm(false)}
          />
        </div>
      )}

      {loading ? (
        <p className="adm-loading">Loading app update configs…</p>
      ) : (
        <div className="adm-table-wrap">
          <table className="adm-table">
            <thead>
              <tr>
                <th>Platform</th>
                <th>Package Name</th>
                <th>Latest Version</th>
                <th>Min Supported</th>
                <th>Active</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {updates.length === 0 ? (
                <tr><td colSpan="6" className="adm-empty">No app update configs found</td></tr>
              ) : (
                updates.map((u) => (
                  <tr key={u.id}>
                    <td><span className="adm-badge adm-badge-blue">{u.platform}</span></td>
                    <td>{u.packageName}</td>
                    <td>{u.latestVersionName} <span style={{ color: "#94a3b8", fontSize: "0.75rem" }}>({u.latestVersionCode})</span></td>
                    <td>{u.minSupportedVersionCode}</td>
                    <td>
                      <label className="switch">
                        <input type="checkbox" checked={u.active} onChange={() => toggleEnable(u.id, u.active)} />
                        <span className="slider"></span>
                      </label>
                    </td>
                    <td>
                      <div style={{ display: "flex", gap: 6 }}>
                        <button className="adm-btn adm-btn-ghost adm-btn-sm" onClick={() => { setEditing(u); setShowForm(true); }}>Edit</button>
                        <button className="adm-btn adm-btn-danger adm-btn-sm" onClick={() => deleteAppUpdate(u.id)}>Delete</button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </AdminPageLayout>
  );
};

export default AdminAppUpdatePage;
